import moment from 'moment'

export const mapCouponFromJSON = coupon => {
  const types = {
    absolute: 'Absoluto',
    percentage: 'Percentual',
  }

  return {
    ...coupon,
    discount_type: types[coupon.discount_type],
  }
}

export const mapCouponToInitialValues = coupon => ({
  ...coupon,
  billing_statuses_permited: coupon.billing_statuses_permited ? coupon.billing_statuses_permited : [],
  status: coupon.is_active ? 'active' : 'inactive',
  ceiling_price: coupon.ceiling_price ? coupon.ceiling_price : '',
  usage_limit_quantity: coupon.usage_limit_quantity ? coupon.usage_limit_quantity : '',
  expiration_date: coupon.expiration_date ? moment(coupon.expiration_date) : '',
})
